import { useRef, useLayoutEffect, useState, useEffect } from 'react'
import create from 'zustand'

type State = {
  pct: number
}

const useStore = create<State>(() => ({
  pct: 0
}))

const usePctChange = (callback: (pct: number) => void): null => {
  const subscribe = useRef()

  useEffect(() => {
    if (subscribe & subscribe.current) {
      console.log('Unsubscribe')
      subscribe.current()
    }
    console.log('Subscribe')
    subscribe.current = useStore.subscribe(() => {
      callback(useStore.getState().pct)
    })
  }, [subscribe, callback])

  return null
}

export { useStore, usePctChange }
